import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ToolbarWrapper from 'components/templates/Wrappers/Toolbars/ToolbarWrapper/ToolbarWrapper';

const StyledHydrateBarWrapper = styled(ToolbarWrapper)`
  height: 100vh;

  .PageBar-title {
    max-width: unset;
  }

  .PageBar-rightFields {
    order: 2;
    max-width: fit-content;

    .Form-fields {
      flex-direction: row;

      .FormField {
        width: ${props => props.theme.layout(200)};
      }
    }
  }
  .PageBar-rightSwitches {
    order: 1;
    margin-right: ${props => props.theme.spacing(4)};
  }
  .PageBar-rightActions {
    order: 3;
  }

  ${ComponentStyles}
`;

StyledHydrateBarWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledHydrateBarWrapper;
